export default __webpack_public_path__ + "static/media/wf-isf-engaging_employees_on_sustainability_767x577.4de35363.jpg";